import { createSlice } from "@reduxjs/toolkit";
import { fetchProfitLoss } from "./profitLoss.thunk";

const initialState = {
  data: [],
  summary: {
    income: 0,
    expense: 0,
    profit: 0,
  },
  loading: false,
  error: null,
};

const profitLossSlice = createSlice({
  name: "profitLoss",
  initialState,

  reducers: {
    clearProfitLoss: (state) => {
      state.data = [];
      state.summary = {
        income: 0,
        expense: 0,
        profit: 0,
      };
    },
  },

  extraReducers: (builder) => {
    builder

      /* ================= FETCH ================= */
      .addCase(fetchProfitLoss.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchProfitLoss.fulfilled, (state, action) => {
        state.loading = false;

        state.data = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];

        state.summary = action.payload?.summary || {
          income: 0,
          expense: 0,
          profit: 0,
        };
      })

      .addCase(fetchProfitLoss.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Failed to fetch profit & loss";
      });
  },
});

export const { clearProfitLoss } = profitLossSlice.actions;

export default profitLossSlice.reducer;